(function(){'use strict';
 function init(){document.querySelectorAll('.nb-premium-header #menu-drawer .nb29-iphone-toggle:not([data-nb29-ready])').forEach(function(btn){
   const panel=document.getElementById(btn.getAttribute('aria-controls'));if(!panel)return;
   btn.setAttribute('data-nb29-ready','true');
   btn.addEventListener('click',function(event){
     event.preventDefault();
     event.stopPropagation();
     const on=btn.getAttribute('aria-expanded')!=='true';
     btn.setAttribute('aria-expanded',String(on));
     panel.hidden=!on;
   });
 });}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();